module.exports = {
  cellStyleConstants: {
    default: 'CELL_STYLE_DEFAULT',
    subtitle: 'CELL_STYLE_SUBTITLE',
  },
};
